<template>
	<div class="layout"
		:class="isColor == 1 ? 'mo' : isColor == 2 ? 'lan' : isColor == 3 ? 'green' : isColor == 4 ? 'qing' : isColor == 5 ? 'orange' : isColor == 6 ? 'red' : ''">
		<ce-header></ce-header>
		<ce-main class="mainBox"></ce-main>
		<ce-footer v-if="$route.meta.showFooter" :style="{ display: $route.meta.name == '一键志愿填报' ? 'none' : 'block' }">
		</ce-footer>
	</div>
</template>
<script>
	// 母版页
	import ceHeader from './header.vue';
	import ceMain from './main.vue';
	import ceFooter from './footer.vue';
	export default {
		name: 'layout',
		components: {
			ceHeader,
			ceMain,
			ceFooter
		},
		data() {
			return {
				isColor: 0
			};
		},
		mounted() {
			this.GetWebSet();
		},
		methods: {
			// 获取网站配置
			GetWebSet: function() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetColor',
					'GET', {},
					function(res) {
						if (res.code === 0) {
							that.isColor = res.data;
						}
					},
					function(res) {}
				);
			}

		}
	};
</script>
<style lang="scss" scoped>
	.mainNei {
		overflow: hidden;
		margin-top: 120px;
	}

	.mainBox {
		padding-top: 120px;
		flex-grow: 1;
		flex-shrink: 1;
	}

	.layout {
		min-height: 100vh;
		display: flex;
		flex-direction: column;
	}
</style>
